export default __webpack_public_path__ + "assets/images/2fec19c3624d788738d4dd15949c2fe7.png";